import { useState, Fragment, useRef, useEffect } from 'react';
import '../../assets/css/account.css'
import Layout from './../../components/Layout/Layout';
import React from "react";
import { Dialog, Transition } from '@headlessui/react'
import fire from './../../utils/Toastr';
import { formatDate } from '../../utils/convertDate';
import { HollowDotsSpinner } from 'react-epic-spinners';
import BusinessServices from '../../services/BusinessServices';
import { useReactState } from '../../utils/useReactState';



export default function BusinessView() {
    const id = new URLSearchParams(window.location.search).get("id");


    const state = useReactState({
        doc: [],
        acct: {},
        businessClass: [],
        businessSector: [],
        formValue: {},
        description: "",
        open: false,
        formState: {
            businessSectorIdError: "",
            businessSectorIdIsValidated: false,
            descriptionError: "",
            descriptionIsValidated: false,
            accountClassError: "",
            accountClassIsValidated: false,
            formIsSubmitting: false,
        }

    })
    const cancelButtonRef = useRef(null)



    // const [formState, setFormState] = useState(errors);
    const [loading, setLoading] = useState({ loading: false });

    const getBusinessClass = async () => {
        const resp = await BusinessServices.listBusinesClass();
        state.businessClass = ([...resp.data]);
    }
    const getBusinessSector = async () => {
        const resp = await BusinessServices.listBusinessSector();
        state.businessSector = ([...resp.data]);
    }

    const listDocument = async () => {
        const resp = await BusinessServices.viewBusinessAccount(id);
        if (!resp) {
            fire("errror", resp.message);
            return;
        }
        state.doc = [...resp.data.businessAccountDocuments];
        state.acct = resp.data
    }

    const approve = async () => {
        setLoading({ loading: true });
        const isFiiled = state.formState.descriptionIsValidated;
        if (!isFiiled) {
            fire("error", "Field is required");
            return;
        }
        const resp = await BusinessServices.actionBusinessAccount({
            businessOwnerUserName: id,
            accountClass: state.formValue.accountClass,
            description: state.formValue.description,
            businessSectorId: state.formValue.businessSectorId
        })
        if (!resp) {
            setTimeout(() => {
                window.location.reload();
                window.location.href = "/business/accounts"
            }, 3000);
            return;

        }
        fire("success", resp.message);
        setTimeout(() => {
            window.location.reload();
            window.location.href = "/business/accounts"
        }, 3000);

        setLoading({ loading: false });
    }

    // comments Modal
    const handleApprove = async () => {
        state.open = (true);
    }

    const handleClose = () => {
        state.open = (false);
    }



    // comment validation
    const formHandler = {
        descriptionHandler: (event) => {
            state.formValue.description = event.target.value;
            state.description = event.target.value;
            if (event.target.value.trim().length < 1) {
                state.formState.descriptionError = "Description cannot be empty";
                state.formState.descriptionIsValidated = false;
                return;
            }
            state.formState.descriptionError = "";
            state.formState.descriptionIsValidated = true;
        },
        sectorHandler: (event) => {
            state.formValue.businessSectorId = parseInt(event.target.value);
            if (event.target.value.trim().length < 1) {
                state.formState.businessSectorIdError = "Business sector cannot be empty";
                state.formState.businessSectorIdIsValidated = false;
                return;
            }
            state.formState.businessSectorIdError = "";
            state.formState.businessSectorIdIsValidated = true;
        },
        accountClassHandler: (event) => {
            state.formValue.accountClass = event.target.value;
            if (event.target.value.trim().length < 1) {
                state.formState.accountClassError = "Business class cannot be empty";
                state.formState.accountClassIsValidated = false;
                return;
            }
            state.formState.accountClassError = "";
            state.formState.accountClassIsValidated = true;
        },
    }

    useEffect(() => {
        listDocument();
        getBusinessClass();
        getBusinessSector();
    }, [])
    return (<>

        <Layout title="" pageTag={'account'} current={'/view/business'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto'>
                        <div className=''>

                            <div className='flex justify-center'><h4 className='font-bold'>{state.acct.customerLastName} {state.acct.customerFirstName} <br /> <span className='font-thin'>{state.acct.accountNumber}</span></h4></div>

                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">
                                        <div className="mt-1 relative">
                                            <h2 className="font-semibold text-gray-900">Customer's Uploads</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <ul className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                                                {state.doc.length === 0 ? 
                                                <>
                                                 <div className="my-2"> No document available  </div>
                                                </> 
                                                :
                                                 <>
                                                {state.doc.map((document, i) => (
                                                    <li key={i} className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
                                                        <div className="flex-1 flex flex-col p-8">
                                                            <div className="flex">
                                                                <img className="w-32 h-32 flex-shrink-0 mx-auto" src={document.documentUrl} alt="" />
                                                            </div>
                                                        </div>
                                                        <p>{document.documentName}</p>
                                                    </li>
                                                ))}
                                                </>}
                                              

                                            
                                            </ul>


                                        </div>
                                    </div>
                                </div>
                                {/* Required details */}
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                                            <form>

                                                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                    <div className='inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                        {/* form */}
                                                        <div className='px-6'>
                                                            <h4>ACCOUNT INFORMATION</h4>
                                                            <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="customerUserName" className="block text-sm font-medium text-gray-700">
                                                                        Customer Username <span className='text-red-600'>*</span>
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="customerUserName" id="customerUserName" value={state.acct.businessOwnerUserName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="customerFirstName" className="block text-sm font-medium text-gray-700">
                                                                        Customer First Name <span className='text-red-600'>*</span>
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="customerFirstName" id="customerFirstName" value={state.acct.businessOwnerFirstName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="customerLastName" className="block text-sm font-medium text-gray-700">
                                                                        Customer Last Name <span className='text-red-600'>*</span>
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="customerLastName" id="customerLastName" value={state.acct.businessOwnerLastName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-6">
                                                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                                                                        Address
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="address" id="address" value={state.acct.address} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="firsemail" className="block text-sm font-medium text-gray-700">
                                                                        FIRS Email Address
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="firsemail" id="firsemail" value={state.acct.firsemail} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="firsrcnumber" className="block text-sm font-medium text-gray-700">
                                                                        RC Number
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="firsrcnumber" id="firsrcnumber" value={state.acct.firsrcnumber} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="inputtedRcNumber" className="block text-sm font-medium text-gray-700">
                                                                        Inputted RC Number
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="inputtedRcNumber" id="inputtedRcNumber" value={state.acct.inputtedRcNumber} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="taxOfficeName" className="block text-sm font-medium text-gray-700">
                                                                        Tax Office Name
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="taxOfficeName" id="taxOfficeName" value={state.acct.taxOfficeName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="taxPayerName" className="block text-sm font-medium text-gray-700">
                                                                        Tax Payer Name
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="taxPayerName" id="taxPayerName" value={state.acct.taxPayerName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="dateCreated" className="block text-sm font-medium text-gray-700">
                                                                        Date Created
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="dateCreated" id="dateCreated" value={formatDate(state.acct.dateCreated)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="businessNature" className="block text-sm font-medium text-gray-700">
                                                                        Business Nature
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="businessNature" id="businessNature" value={state.acct.businessNature} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="registeredBusinessState" className="block text-sm font-medium text-gray-700">
                                                                        Registered Business State
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="registeredBusinessState" id="registeredBusinessState" value={state.acct.registeredBusinessState} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>  <div className="sm:col-span-2">
                                                                    <label htmlFor="registeredBusinessAddress" className="block text-sm font-medium text-gray-700">
                                                                        Registered Business Address
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="registeredBusinessAddress" id="registeredBusinessAddress" value={state.acct.registeredBusinessAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
                                                                        Phone Number
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="phoneNumber" id="phoneNumber" value={state.acct.phoneNumber} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="emailAddress" className="block text-sm font-medium text-gray-700">
                                                                        Email Address
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="emailAddress" id="emailAddress" value={state.acct.emailAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>  <div className="sm:col-span-2">
                                                                    <label htmlFor="businessWebsite" className="block text-sm font-medium text-gray-700">
                                                                        Business Website
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="businessWebsite" id="businessWebsite" value={state.acct.businessWebsite} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="businessCategory" className="block text-sm font-medium text-gray-700">
                                                                        Business Category
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="businessCategory" id="businessCategory" value={state.acct.operatingBusinessAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>
                                                                <div className="sm:col-span-2">
                                                                    <label htmlFor="businessDocumentUploadStatus" className="block text-sm font-medium text-gray-700">
                                                                        Document Upload Status
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="businessDocumentUploadStatus" id="businessDocumentUploadStatus" value={state.acct.businessDocumentUploadStatus} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div> <div className="sm:col-span-2">
                                                                    <label htmlFor="requestStatus" className="block text-sm font-medium text-gray-700">
                                                                        Request Status
                                                                    </label>
                                                                    <div className="mt-1">
                                                                        <input type="text" name="requestStatus" id="requestStatus" value={state.acct.requestStatus} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='flex justify-end bg-white p-6'>
                                                    <button
                                                        type='button'
                                                        className='btn-secondary  align-center flex justify-center items-center rounded-md border px-8 py-2 text-sm font-medium text-black shadow-sm  sm:w-auto'
                                                        onClick={() => handleApprove()}>Update Account</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>
                {/* Approve modal */}
                <Transition.Root show={state.open} as={Fragment}>
                    <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed z-10 inset-0 overflow-y-auto">
                            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xl sm:w-full sm:p-6">
                                        <div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                                    Hey, wait!!
                                                </Dialog.Title>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">
                                                        Are you sure you want to update this business account?
                                                    </p>
                                                    <form>
                                                        <label htmlFor="description" className="text-left mt-2 block text-sm font-medium text-gray-700">Description</label>
                                                        <div className="mt-1">
                                                            <input
                                                                id="description"
                                                                name="description"
                                                                type="text"
                                                                placeholder='Enter description'
                                                                value={state.formValue.description}
                                                                onChange={formHandler.descriptionHandler}
                                                                required
                                                                className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            />
                                                            {!state.formState.descriptionIsValidated && state.formState.descriptionError && (
                                                                <div className="text-red-800">
                                                                    {state.formState.descriptionError}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <label htmlFor="businessSector" className="text-left mt-2 block text-sm font-medium text-gray-700">Business Sector</label>
                                                        <div className="mt-1">
                                                            <select
                                                                className="focus:ring-indigo-500 focus:border-indigo-500 py-4 w-full border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                                                value={state.formValue.businessSectorId}
                                                                onChange={formHandler.sectorHandler}
                                                            >
                                                                <option>Select business sector</option>
                                                                {state.businessSector.map((item, i) =>
                                                                    <option key={i} value={item.id}>{item.industryName}</option>
                                                                )}
                                                            </select>

                                                            {!state.formState.businessSectorIdIsValidated && state.formState.businessSectorIdError && (
                                                                <div className="text-red-800">
                                                                    {state.formState.businessSectorIdError}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <label htmlFor="businessSector" className="text-left mt-2 block text-sm font-medium text-gray-700">Business Class</label>
                                                        <div className="mt-1">
                                                            <select
                                                                className="focus:ring-indigo-500 focus:border-indigo-500 py-4 w-full border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                                                value={state.formValue.accountClass}
                                                                onChange={formHandler.accountClassHandler}
                                                            >
                                                                <option>Select business class</option>
                                                                {state.businessClass.map((item, i) =>
                                                                    <option key={i} value={item.accountClass}>{item.description}</option>
                                                                )}
                                                            </select>

                                                            {!state.formState.accountClassIsValidated && state.formState.accountClassError && (
                                                                <div className="text-red-800">
                                                                    {state.formState.accountClassError}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                            {loading.loading === false ?
                                                <button
                                                    type="button"
                                                    className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                                    onClick={(text) => approve(text)}
                                                >
                                                    Yes, I do
                                                </button> : <HollowDotsSpinner size={20} color="#4D627E" />}

                                            <button
                                                type="button"
                                                className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                                                onClick={() => handleClose()}

                                                ref={cancelButtonRef}
                                            >
                                                No, I dont
                                            </button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>

            </React.Fragment>
        </Layout>


    </>);
}